module.exports = "/cyber/_next/static/images/faq-bg-tablet-258ed365bd31bc554827946c10ba754d.jpg";